import styled from "styled-components";
import Text from "@streeteasy/design-system/deprecated/Text";
import Title from "@streeteasy/design-system/deprecated/Title";

import { smallScreen } from "../../../../shared/constants/screenSizes";

export const FormContent = styled.div`
  padding: 70px;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 40px 52px 92px;
  }
`;

export const FormTitle = styled(Title).attrs({
  as: "h2",
  type: "primarySm"
})`
  margin-bottom: 15px;
`;

export const FormDescription = styled(Text).attrs({ type: "sm" })`
  margin-bottom: 20px;

  @media screen and (max-width: ${smallScreen}px) {
    font-size: 16px;
  }
`;
